<template>
  <div class="desbut">
    <!-- 
      bordered
      size="small"
      layout="horizontal"
      labelStyle="table_des"
     -->
    <a-descriptions
      title=""
      bordered
      size="middle"
      labelStyle="table_des"
      :column="{ xxl: 4, xl: 4, lg: 2, md: 2, sm: 2, xs: 1 }"

    >
      <a-descriptions-item
        v-for="(item, index) in rowListData.colum"
        :key="index"
        :label="!item.show ? item.label : ''"
        :span="item.span != undefined ? item.span : '1'"
      >
        <div :class="item.isFull?'width_full':'width_div'" v-if="!item.show && !item.linkUrl">
          <!--
               endunit  末尾单位
                judge：是否判断
           -->
          <!-- {{item.prop}} -->
          <!-- {{
            item.prop == "-1"
              ? "-"
              : item.prop == "" && !item.show
              ? "-"
              : item.judge
              ? item.prop == 0
                ? "否"
                : "是"
              : item.endunit != undefined
              ? item.prop + item.endunit
              : item.prop
          }} -->
          {{
            infoData[item.prop.trim()] === undefined ||infoData[item.prop.trim()] === ""
              ? "/"
              : item.formatter
              ? item.formatter(item.label, item.propInner?infoData[item.prop.trim()][item.propInner]:infoData[item.prop.trim()])
              : item.unit
              ? `${item.propInner?infoData[item.prop.trim()][item.propInner]:infoData[item.prop.trim()]}${item.unit}`
              : item.propInner?infoData[item.prop.trim()][item.propInner]:infoData[item.prop.trim()]
          }}

          <!-- {{
            item.prop == "-1" || (item.prop == "" && !item.show)
              ? "-"
              : item.endunit != undefined
              ? item.prop + item.endunit
              : item.judge
              ? item.prop == 0
                ? "否"
                : "是"
              : item.prop
          }} -->
        </div>
        <div
          :class="item.prop && item.prop!='-'?'link-line':''"
          v-if="item.linkUrl"
          @click="goLink(item.propName)">
          {{item.prop}}
        </div>   
      </a-descriptions-item>
      <!-- :class="rowListData.enclosure ==undfined?'none':''" -->
      <a-descriptions-item
        label="附件信息"
        :span="2"
        v-if="rowListData.enclosure ? true : false"
      >
        <a-spin :spinning="spinning">
          <template v-for="(item, index) in infoData.file">
            <div class="file_wrapper" :key="index">
              <a
                class="file_button"
                target="_blank"
                :href="
                  isWord(item.fileUrl)
                    ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' + item.fileUrl
                    : item.fileUrl
                "
                type="text"
                size="small"
              >
                {{ item.fileName }}
              </a>
              <i
                @click="downLoadFile(item.id)"
                class="el-icon-download del_icon"
              ></i>
            </div>
          </template>
        </a-spin>
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
import { downLoadTemplate } from "@/router/downLoadTem";

import * as dictionaries from "@/api/zd/dictionaries";
export default {
  data() {
    return {
      ListData: [],
      spinning: true,
    };
  },
  computed: {},
  watch: {
    infoData: {
      deep: true,
      handler() {
        // this.onload(this.rowListData);
        if (this.rowListData.enclosure) {
          if (this.rowListData.enclosure.name == "员工详细信息附件") {
            this.getFileMenuByName(
              this.infoData.userId,
              this.rowListData.enclosure.name,
              "file"
            );
          } else {
            this.getFileMenuByName(
              this.infoData.id,
              this.rowListData.enclosure.name,
              "file"
            );
          }
        }

        // if (this.rowListData.enclosure != undefined) {
        //   this.getFileMenuByName(
        //     this.data.id,
        //     this.rowListData.enclosure.name,
        //     "file"
        //   );
        // }
      },
    },
  },
  created() {
    // this.onload(this.rowListData);
    if (this.rowListData.enclosure) {
      if (!this.infoData.id) {
        return;
      }
      if (this.rowListData.enclosure) {
        if (this.rowListData.enclosure.name == "员工详细信息附件") {
          this.getFileMenuByName(
            this.infoData.userId,
            this.rowListData.enclosure.name,
            "file"
          );
        } else {
          this.getFileMenuByName(
            this.infoData.id,
            this.rowListData.enclosure.name,
            "file"
          );
        }
      }
    }
  },
  props: {
    rowListData: {
      type: Object,
      default() {
        return {}
      },
    },
    infoData: {
      type: Array,
      default() {
        return []
      },
    },
    labelName: {
      type: String,
      default() {
        return '附件文档'
      }
    }
  },
  methods: {
    goLink(prop) {
      let fileUrl = ''
      if(prop == 'fileName') {
        fileUrl = this.infoData.fileNameData.fileUrl
      }else if(prop == 'checkFileName') {
        fileUrl = this.infoData.checkFileNameData.fileUrl
      }
      let openUrl = this.isWord(fileUrl)
                    ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' + fileUrl
                    : fileUrl
      window.open(openUrl, "_blank")
    },
    // onload(name) { 
    //   if (!this.data.id) {
    //     return;
    //   }
    //   let peageData = this.data;
    //   let ListData = [];
    //   if (name.colum.length > 0) {
    //     name.colum.forEach((item) => {
    //       // console.log(eval('peageData.'+item.prop))
    //       let rows = {
    //         ...item,
    //         propName: item.prop,
    //         prop: eval("peageData." + item.prop),
    //         show:
    //           item.show != undefined
    //             ? eval("peageData." + item.show)
    //             : undefined,
    //       };
    //       return ListData.push(rows);
    //     });

    //     this.ListData = ListData;
    //   }
    // },
    //通过名称获取菜单
    getFileMenuByName(id, fileMenuName, name) {
      dictionaries
        .getFileMenuByName({ fileMenuName })
        .then((res) => {
          this[name] = res.data.data.id;
          this.findFileByOtherId(id, res.data.data.id, name);
        })
        .catch((res) => {
          
        });
    },
    findFileByOtherId(id, baFileMenuId, name) {
      dictionaries
        .findFileByOtherId({
          fileOtherId: id,
          baFileMenuId: baFileMenuId,
        })
        .then((res) => { 
          this.infoData[name] = res.data.data;
          this.spinning = false;
        })
        .catch((res) => {});
    },
    //下载附件
    downLoadFile(id) {
      downLoadTemplate("/api/file/down", {
        id,
      }).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },

    //附件内容
    showFileName(data) {
      this.infoData.file = data;
      // this.form.fileId = data.id;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.ant-descriptions-bordered .ant-descriptions-item-label {
  text-align: right;
  
}
.link-line{
  cursor: pointer;
  text-decoration:underline;
}
.link-line:hover{
  color: #409EFF;
}
.width_div {
  // min-width: 240px;
}
.width_full{
  width: 100%;
}
.desbut {
  margin-bottom: 25px;
}
.none {
  display: none;
}
.file_wrapper{
    // padding:0px 15px 5px;
    color: rgba(0, 0, 0, 0.65) !important;
    a{
      margin-right: 15px;
      color: rgba(0, 0, 0, 0.65) !important;
    }
    i{
      margin-right: 5px;
      cursor: pointer;
    }
}
// .table_des {
//   width:100px;
// }
/deep/ .ant-descriptions-item-label,/deep/.ant-descriptions-item-content {
  font-size: 12px !important;
  width:12.5%;
  
}
/deep/ .ant-descriptions-item-label {
  padding: 10px 4px 10px 0 !important;
}
/deep/ .ant-descriptions-item-content {
  padding: 10px 10px !important;
}
</style>